<template>
  <div class="move-search">
    <div class="search" :class="{ error: error }">
      <div class="icon">
        <img src="../../assets/imgs/icon-mg.png" />
      </div>
      <input
        v-model="zipCode"
        readonly
        onfocus="this.removeAttribute('readonly');"
        onblur="this.setAttribute('readonly',true);"
        autocomplete="off"
        placeholder="Enter your starting ZIP"
        @input="change"
        @keyup.enter="calculate"
      />
    </div>
    <div class="btn" @click="calculate">
      <span>Get A Quote</span>
    </div>
  </div>
</template>

<script>
import { googleAdGetQuote } from '@/utils/googleads';

export default {
  name: 'MoveSearch',
  data() {
    return {
      zipCode: '',
      error: false,
    };
  },
  mounted() {
    // this.initBus();
  },
  methods: {
    calculate() {
      this.$emit('calculateZipcode', this.zipCode);
      googleAdGetQuote();
    },
    change() {
      this.error = false;
      setTimeout(() => {
        this.$store.commit('home/updateZipcode', this.zipCode);
      }, 500);
      this.$emit('change', this.zipCode);
    },
    setError(error = true) {
      this.error = error;
    },
  },
};
</script>

<style lang="less" scoped>
.move-search {
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  .search {
    &.error {
      border: 1px solid red;
    }
    width: 278px;
    height: 46px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    border: 1px solid #d8dce2;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    .icon {
      width: 26px;
      height: 15px;
      background-color: #f2f2f2;
      img {
        width: 100%;
      }
    }
    input {
      width: 100%;
      padding: 0 0 0 20px;
    }
  }
  .btn {
    width: 109px;
    height: 46px;
    margin-left: 10px;
    line-height: 46px;
    text-align: center;
    background: #6e6def;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    font-size: 14px;
    font-family: Montserrat-Light, Montserrat;
    font-weight: 300;
    color: #ffffff;
    text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  }
}
</style>
